import React from "react";
import { Result } from "antd";
import { useHistory } from "react-router-dom";
export default function UnAuthorized({ subText = "any active roles" }) {
    var _a, _b;
    const history = useHistory();
    return (React.createElement(Result, { status: "403", subTitle: `You do not have ${(_b = (_a = history.location.state) === null || _a === void 0 ? void 0 : _a.subText) !== null && _b !== void 0 ? _b : subText} that allow you access to data.Please contact your administrator if you require access.` }));
}
